import Simple from './simple';
import Complex from './complex';
import Progress from './progress';
const Alert = {};
Alert.Simple = Simple;
Alert.Complex = Complex;
Alert.Progress = Progress;
export default Alert;
//# sourceMappingURL=index.js.map